import React, { useState, useEffect } from "react";
import SalesRepsReportForm from "./salesReport";
import Header from "../../../header/header";
import Navvbar from "../../../header/Navvbar";
import axios from 'axios';
import { format } from 'date-fns';
import { Spinner, Alert } from "react-bootstrap";

const Addsalereport = () => {
  const [showParam, setShowParam] = useState(true);
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [accountOptions, setAccountOptions] = useState([]);

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const response = await axios.get('https://hms.backend.hiragroupcloud.com/api/account/account');
        const accounts = response.data.data.map(account => ({
          value: account._id,
          label: account.account_name,
        }));
        setAccountOptions([{ value: '', label: '✨ All Accounts' }, ...accounts]);
      } catch (err) {
        setError('Could not fetch accounts. Please try again later.');
        console.error(err);
      }
    };
    fetchAccounts();
  }, []);

  const runReport = async (params) => {
    
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get('https://hms.backend.hiragroupcloud.com/api/invoices/sales-report', {
        params: {
          start_date: params.start_date,
          end_date: params.end_date,
          reps: params.reps.includes('') ? [] : params.reps // Exclude 'All' if selected
        }
      });
      setReportData(response.data);
      setShowParam(false);
    } catch (err) {
      console.error('Error in runReport:', err);
      setError(err.response?.data?.error || 'Failed to generate report. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), 'MMM d, yyyy');
    } catch {
      return dateString;
    }
  };

  const handleReset = () => {
    setShowParam(true);
    setReportData(null);
    setError(null);
  };

  return (
    <>
      <Header />
      <Navvbar />
      <br />
      <div
        style={{
          marginTop: "20px",
          padding: "10px",
          width: "75%",
          margin: "10px auto",
          marginLeft: "225px",
        }}
      >
        <div className="container mt-3" style={{ display: "flex", justifyContent: "space-between" }}>
          <h3>
            {reportData 
              ? `Sales Report: ${formatDate(reportData.summary.startDate)} to ${formatDate(reportData.summary.endDate)}`
              : 'Sales Report'}
          </h3>
          <div className="col-md-3 d-flex justify-content-end">
            {reportData ? (
              <button
                onClick={handleReset}
                style={{
                  backgroundColor: "#6c757d",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "16px",
                  cursor: "pointer",
                  height: "45px",
                  marginRight: "10px"
                }}
              >
                Reset
              </button>
            ) : null}
            <button
              onClick={() => setShowParam(!showParam)}
              style={{
                backgroundColor: "#004aad",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                cursor: "pointer",
                height: "45px"
              }}
            >
              {showParam ? 'Hide Parameters' : 'Parameters'}
            </button>
          </div>
        </div>
        
        {showParam && (
          <div id="addFile">
            <SalesRepsReportForm 
              onRunReport={runReport} 
              accountOptions={accountOptions} 
              setError={setError}
            />
          </div>
        )}
        
        {loading && (
          <div className="text-center my-4">
            <Spinner animation="border" variant="primary" />
            <p>Generating report...</p>
          </div>
        )}
        
        {error && (
          <div className="alert alert-danger my-4">
            {error}
          </div>
        )}
        
        {reportData && (
          <>
            <h5 style={{ backgroundColor: "white", color: "#004aad", fontWeight: "bold", padding: "10px 0" }}>Summary</h5>
            <div style={{
              backgroundColor: "#f0f0f0",
              borderTop: "2px solid #004aad",
              padding: "20px",
              margin: "10px 0",
              borderRadius: "5px"
            }}>
              <div className="d-flex justify-content-between" style={{ marginBottom: "15px" }}>
                <div style={{ fontWeight: "bold", width: "33%" }}>Total Sales</div>
                <div style={{ fontWeight: "bold", width: "33%", textAlign: "center" }}>Number of Invoices</div>
                <div style={{ fontWeight: "bold", width: "33%", textAlign: "right" }}>Number of Accounts</div>
              </div>
              <div className="d-flex justify-content-between" style={{ 
                backgroundColor: "white", 
                padding: "15px", 
                color: "#004aad",
                borderRadius: "5px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }}>
                <div style={{ fontWeight: "bold", width: "33%" }}>£{reportData.summary.totalSales.toFixed(2)}</div>
                <div style={{ fontWeight: "bold", width: "33%", textAlign: "center" }}>{reportData.summary.invoiceCount}</div>
                <div style={{ fontWeight: "bold", width: "33%", textAlign: "right" }}>{reportData.summary.accountCount}</div>
              </div>
            </div>
            
            <br />
            <h5 style={{ fontWeight: "bold", color: "#004aad", padding: "10px 0" }}>Details</h5>
            <div className="border" style={{ borderRadius: "5px", overflow: "hidden" }}>
              <table className="table table-bordered" style={{ marginBottom: "0" }}>
                <thead className="thead-light">
                  <tr>
                    <th style={{ backgroundColor: "#f0f0f0", borderTop: "2px solid #004aad" }}>Account</th>
                    <th style={{ backgroundColor: "#f0f0f0", borderTop: "2px solid #004aad", textAlign: "right" }}>Sales</th>
                    <th style={{ backgroundColor: "#f0f0f0", borderTop: "2px solid #004aad", textAlign: "right" }}>% of Sales</th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.details.map((detail, index) => (
                    <React.Fragment key={index}>
                      <tr style={{ backgroundColor: "#f8f9fa" }}>
                        <td><strong>{detail.account}</strong></td>
                        <td style={{ textAlign: "right" }}><strong>£{detail.sales.toFixed(2)}</strong></td>
                        <td style={{ textAlign: "right" }}><strong>{detail.percentage}</strong></td>
                      </tr>
                      {detail.invoices.map((invoice, idx) => (
                        <tr key={`${index}-${idx}`}>
                          <td style={{ paddingLeft: '30px' }}>
                            Invoice #{invoice.invoiceNumber} ({formatDate(invoice.date)})
                          </td>
                          <td style={{ textAlign: "right" }}>£{invoice.amount.toFixed(2)}</td>
                          <td style={{ textAlign: "right" }}>{(invoice.amount / reportData.summary.totalSales * 100).toFixed(2)}%</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
      <br /><br /><br /><br />
    </>
  );
};

export default Addsalereport;